import api from '../configuration/ApiConfig'
const singleMemberLLCServices={
    AddCustomerServiceQuestion:(form)=>{
    const request = api.post('CustomerServices/AddCustomerServiceQuestion',form)
    return request.then((response)=>{
        return response.data
    })
},
GetCustomerServiceQuestionByCustomerIdAndServiceId:(serviceId)=>{
    const request = api.get('CustomerServices/GetCustomerServiceQuestionByCustomerIdAndServiceId?serviceId='+serviceId)
    return request.then((response)=>{
        return response.data
    })
},
AddCustomerServiceSingleMemberLLCQuestion:(form)=>{
    const request = api.post('CustomerServices/AddCustomerServiceSingleMemberLLCQuestion',form)
    return request.then((response)=>{
        return response.data
    })
},
UpdateCustomerServiceSingleMemberLLCQuestion:(form)=>{
    const request = api.post('CustomerServices/UpdateCustomerServiceSingleMemberLLCQuestion',form)
    return request.then((response)=>{
        return response.data
    })
},
GetCustomerServiceQuestionByCustomerServiceId:(customerServiceId)=>{
    const request = api.get('CustomerServices/GetCustomerServiceQuestionByCustomerServiceId?customerServiceId='+customerServiceId)
    return request.then((response)=>{
        return response.data
    })
},
}
export default singleMemberLLCServices;